import BaseGridFeature from '@src/framework/workbench/common/feature/base-grid-feature';

export default class BaseDrawerGridFeature extends BaseGridFeature {
    /**
     * 获取当前按键的值
     */
    public getFormItemValue(id?) {
        const values = this.getMenuManager()?.propertyMenu().values;
        return values?.[id || this.id] || '';
    }
}
